import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HomeworksComponent } from './components/homeworks/homeworks.component';
import { HomeworksService } from './services/homeworks.service';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from '../../directives/clickOutside';
import { SubmitHomeworkComponent } from './components/submit-homework/submit-homework.component';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { FileUploaderModule } from 'file-uploader';
import { ErrorsModule } from '../../common/errors/errors.module';
import { HomeworkDescriptionAttachmentComponent } from './components/homework-description-attachment/homework-description-attachment.component';
import { BackButtonModule } from '../../common/back-button/back-button.module';
import { LibConfirmModule } from 'lib-confirm';
import { HomeworkDetailsComponent } from './components/homework-details/homework-details.component'
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ClickOutsideModule,
    AuthorizationModule,
    FileUploaderModule,
    ErrorsModule,
    LibConfirmModule,
    BackButtonModule,
    PerfectScrollbarModule
  ],
  exports: [
    HomeworkDescriptionAttachmentComponent,
    HomeworkDetailsComponent
  ],
  declarations: [
    HomeworksComponent, 
    DateSelectorComponent, 
    SubmitHomeworkComponent, 
    HomeworkDescriptionAttachmentComponent,
    HomeworkDetailsComponent
  ],
  providers: [HomeworksService,
    DatePipe,
    {
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}]
})
export class HomeworksModule { }
